<template>
  <div
    v-if="showPros"
    class="margin-top-m"
  >
    <ProsCollection
      :recommendation-config="{ zone: 'PDP_ZONE_E', productId, categoryId }"
      @dataLoadStatusEvent="loader"
    />
  </div>
</template>

<script setup>
import { ProsCollection } from '@common-vue/pros-collection';
import { usePageData } from '@composables/usePageData';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import useProsLoader from '@composables/utils/useProsLoader';

const { taxonomy } = useCommonProductGetters();
const categoryId = taxonomy.value.defaultCategoryId;

const { productId } = usePageData();
const { showPros, loader } = useProsLoader();

</script>
